import React from "react";

const ImageComponent = ({ url, height }) => {
  return (
    <img src={url} height={height} width={500} alt="alt" />
  );
};

export default ImageComponent;
